import {createDailyPromoStorage} from './dailyPromoStorage';

// Приглашение в первый рейтинговый матч (RankedMatchPromoModal в главном
// меню): дата последнего закрытия — повторные показы, пока рейтинговых
// матчей так и нет, не чаще раза в сутки. Отдельной отметки «пора показать»
// не нужно: право на первый показ дает сам профиль (сетевой матч уже был,
// рейтингового нет — см. resolveRankedMatchPromoReason)
export const RANKED_MATCH_PROMO_SHOWN_AT_STORAGE_KEY = 'rankedMatchPromoShownAt';

const dailyStorage = createDailyPromoStorage(RANKED_MATCH_PROMO_SHOWN_AT_STORAGE_KEY);

export const checkIfRankedMatchPromoDue = dailyStorage.checkIfDue;
export const rememberRankedMatchPromoShown = dailyStorage.rememberShown;
export const checkIfRankedMatchPromoEverShown = dailyStorage.checkIfEverShown;
